import { lazy } from "react";

const LessonSchedule = lazy(() => import("@views/Lesson/LessonSchedule"))
const ExaminationSchedule = lazy(() => import("@views/Lesson/ExaminationSchedule"))
const Lesson = lazy(() => import("@views/Lesson/Lesson"))
const Course = lazy(() => import("@views/Lesson/Course"))
const Homework = lazy(() => import("@views/Lesson/Course/Homework"))
const Exam = lazy(() => import("@views/Lesson/Exam/"))
const ScoreTeacher = lazy(() => import("@views/Lesson/ScoreTeacher/"))
const LessonPage = lazy(() => import("@views/Lesson/Lesson/LessonPage"))

const LessonRoutes = [
    {
        path: 'lesson/lesson',
        element: <Lesson />,
    // Хоосон хуудас гаргах үед ашиглана(Sidebar, Header-гүй хуудас)
        // meta: {
        //     layout: 'blank'
        // }
    },
    {
        path: 'lesson/lesson/:id/',
        element: <LessonPage />,
    // Хоосон хуудас гаргах үед ашиглана(Sidebar, Header-гүй хуудас)
        meta: {
            layout: 'blank'
        }
    },



    //////////////////////////
    {
        path: 'lesson/course/:code/',
        element: <Course />
    },
    {
        path: 'lesson/lesson-schedule',
        element: <LessonSchedule />
    },
    {
        path: 'lesson/examination-schedule',
        element: <ExaminationSchedule />
    },
    {
        path: 'lesson/home-work/:code/',
        element: <Homework />,
        meta: {
            layout: 'blank'
        }
    },

    {
        path: 'lesson/exam/:lessonId/:dataId/',
        element: <Exam />,
    },
    {
        path: 'student/score-teacher/',
        element: <ScoreTeacher />,
    }
]

export default LessonRoutes
